import { render } from "./AddRemoveMultipleItems.vue?vue&type=template&id=5d9cccc9&scoped=true&ts=true"
import script from "./AddRemoveMultipleItems.vue?vue&type=script&lang=ts"
export * from "./AddRemoveMultipleItems.vue?vue&type=script&lang=ts"

import "./AddRemoveMultipleItems.vue?vue&type=style&index=0&id=5d9cccc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9cccc9"]])

export default __exports__